import { useEffect, useState } from "react";
import { CalendarCheck, Menu, X } from "lucide-react";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";

const LINKS = [
  ["Servicios", "#servicios"],
  ["Nosotros", "#nosotros"],
  ["Contacto", "#contacto"],
];

export const PublicHeader = ({ onAgendar }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", fn);
    return () => window.removeEventListener("scroll", fn);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-40 transition-[background-color,box-shadow] duration-300 ${
        scrolled || open ? "bg-white/80 shadow-[0_1px_0_rgba(11,37,69,0.06)] backdrop-blur-xl" : "bg-transparent"
      }`}
      data-testid="public-header"
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-5 sm:px-8 lg:h-20">
        <a href="#inicio" data-testid="header-logo-link"><Logo /></a>
        <nav className="hidden items-center gap-9 md:flex">
          {LINKS.map(([label, href]) => (
            <a key={href} href={href} className="text-sm font-medium text-slate-600 transition-colors hover:text-[#1E6FD9]"
               data-testid={`nav-link-${href.slice(1)}`}>{label}</a>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <Button onClick={onAgendar} className="hidden rounded-full bg-[#0B2545] px-5 hover:bg-[#1E6FD9] sm:inline-flex"
                  data-testid="header-agendar-button">
            <CalendarCheck className="mr-2 h-4 w-4" /> Agendar cita
          </Button>
          <button className="grid h-10 w-10 place-items-center rounded-full border border-slate-200 bg-white md:hidden"
                  onClick={() => setOpen((o) => !o)} aria-label="Menú" data-testid="mobile-menu-toggle">
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>
      {open && (
        <div className="border-t border-slate-100 bg-white px-5 pb-5 md:hidden" data-testid="mobile-menu">
          {LINKS.map(([label, href]) => (
            <a key={href} href={href} onClick={() => setOpen(false)} className="block py-3 text-base font-medium text-[#0B2545]">{label}</a>
          ))}
          <Button onClick={() => { setOpen(false); onAgendar(); }} className="mt-2 w-full rounded-full bg-[#1E6FD9]"
                  data-testid="mobile-agendar-button">Agendar cita</Button>
        </div>
      )}
    </header>
  );
};
